import { Search as SearchComponent, csx } from '@vtex/admin-ui'
import type { SimplifiedPromotion } from 'typings'
import { normalizeString } from '../../utils'
import { usePromotionsListState } from '../usePromotionsListState'

export function filterByText(searchTerm: string) {
  const normalizedTerm = normalizeString(searchTerm)

  return (promotion: SimplifiedPromotion) => {
    return (
      promotion.id === searchTerm ||
      normalizeString(promotion.name).includes(normalizedTerm) ||
      normalizeString(promotion.description).includes(normalizedTerm) ||
      promotion.utmSource.some((utm) =>
        utm.toLocaleLowerCase().includes(normalizedTerm)
      ) ||
      promotion.utmCampaign.some((utm) =>
        utm.toLocaleLowerCase().includes(normalizedTerm)
      )
    )
  }
}

type Props = {
  label: string
}

export function Search(props: Props) {
  const { searchState } = usePromotionsListState()
  const { label } = props

  return (
    <SearchComponent
      {...searchState.getInputProps()}
      className={csx({
        width: '3/8',
      })}
      placeholder={label}
    />
  )
}
